import { TableCell, TableSortLabel, Tooltip } from "@mui/material"
import { useBoundContext } from "lib/@components/binding/use-bound-context"
import { ListItemBox } from "lib/@components/ListItemBox"
import { If, Else } from "lib/@components/switch"
import { NeutralSortIcon } from "./neutral-sort-icon"

export function DataTableHeaderCell({ item: column }) {
    const { sort, toggleSort, defaultSort } = useBoundContext()
    const active = sort?.field === column.field
    const direction = active && sort?.descending ? "desc" : "asc"

    return (
        <TableCell
            align={column.align}
            aria-sort={active ? (sort?.descending ? "descending" : "ascending") : undefined}
            sx={{ width: column.width, whiteSpace: "nowrap", ...column.sx }}
            data-cy={`data-table-header-${column.field}`}
        >
            {/* The label sits in a flex row, so the cell's text alignment alone would leave it on the left. */}
            <ListItemBox sx={{ gap: 0.5, justifyContent: column.align === "right" ? "flex-end" : undefined }}>
                <If value={!!column.sortable}>
                    <Tooltip title={getSortTooltip()}>
                        <TableSortLabel
                            active={active}
                            direction={direction}
                            onClick={sortByColumn}
                            IconComponent={active ? undefined : NeutralSortIcon}
                            sx={{
                                "& .MuiTableSortLabel-icon": { opacity: active ? 1 : 0.5 },
                                "&.Mui-focusVisible": {
                                    backgroundColor: "action.focus",
                                    borderRadius: 1,
                                },
                            }}
                        >
                            {column.label}
                        </TableSortLabel>
                    </Tooltip>
                    <Else>{column.label}</Else>
                </If>
                {column.filter}
            </ListItemBox>
        </TableCell>
    )

    function sortByColumn() {
        toggleSort(column.field)
    }

    function getSortTooltip() {
        if (!active) return "Sort By Ascending"
        if (!sort?.descending) return "Sort By Descending"
        return defaultSort?.field === column.field ? "Sort By Ascending" : "Clear Sort"
    }
}
